<template>
  <div class="top-bar-container">
    <v-app-bar flat dense class="top-bar" height="48">
      <v-spacer></v-spacer>

      <div class="user-info">

        <v-icon color="#0d2c6d" class="user-icon">mdi-account-circle</v-icon>
        <span class="user-name">
          <b>Connected: </b>{{ userName }} {{ business_name }}
        </span>
        <v-btn v-if="role === 'admin'" small text class="line-number-btn" @click="showLogs()">
          <v-icon small left color="#0d2c6d">mdi-chevron-left</v-icon>
          <span class="line-number">{{ lineNumber }}</span>
        </v-btn>
        <v-btn v-else disabled small text class="line-number-btn">
          <v-icon small left color="#0d2c6d">mdi-chevron-left</v-icon>
          <span class="line-number">{{ lineNumber }}</span>
        </v-btn>
        <v-btn icon small class="action-btn" title="Logout" @click="logout()">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </div>

    </v-app-bar>
  </div>
</template>

<script>
import Auth from '@/services/auth.service.js'
import { mapState, mapMutations } from 'vuex';

export default {
  data: () => ({
  }),
  methods: {
    showLogs() {
      if (this.role === "admin") {
        this.$router.push({ name: 'logs' });
      }
    },
    logout() {
      localStorage.removeItem("token");
      this.$router.replace({ name: 'login' });
    },
  },
  computed: {
    ...mapState(['lineNumber', "userName", "business_name", "role"]), // Get Vuex state
  },
  created() {
  },
}
</script>

<style scoped>
.top-bar-container {
  width: 100%;
}

.top-bar {
  background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.user-info {
  display: flex;
  align-items: center;
  direction: ltr;
  padding: 0 8px;
}

.user-icon {
  margin-left: 8px;
  /* Changed from margin-right */
}

.user-name {
  font-size: 14px;
  color: #0d2c6d;
  margin-left: 12px;
  /* Changed from margin-right */
}

.line-number {
  font-size: 14px;
  font-weight: 600;
  color: #0d2c6d;
  text-decoration: none;
}

.line-number-btn {
  margin-right: 8px;
  /* Changed from margin-left */
  padding: 0 8px;
  height: 28px;
  border-radius: 14px;
  background-color: rgba(13, 44, 109, 0.1);
  transition: all 0.2s ease;
}

.line-number-btn:hover {
  background-color: rgba(13, 44, 109, 0.2);
  transform: translateY(-1px);
}

.action-btn {
  margin-left: 4px;
  /* Changed from margin-right */
}
</style>